var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreePages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108,
    height: 111,
    viewBox: "0 0 108 111",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.7099 26.1037V13.0519H64.6159L50.7263 0H0V83.9261H16.1084V96.978H32.2173V110.03H107.819V26.1037H91.7099ZM52.7638 11.1588L54.7784 13.0519L60.3251 18.2639L63.726 21.4597H52.764L52.7638 11.1588ZM6.95634 77.3895V6.53668H45.8075V27.9966H68.6447V77.3895H16.1084H6.95634ZM23.0647 90.4413V83.9261H75.601V23.3745L71.572 19.5885H84.7531V26.1037V90.4413H32.2173H23.0647ZM100.862 103.493H39.1736V96.978H91.7101V32.6404H100.862V103.493H100.862Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreePages);
export default __webpack_public_path__ + "static/media/ThreePages.6c46d5bc0ca5c7c96f2d5c567798823f.svg";
export { ForwardRef as ReactComponent };